import styled from 'styled-components';
import { NumericFormat } from 'react-number-format';
import { Colors } from '~/constants';

const {
  MUTED_PURPLE,
  DARK_GREY,
  WHITE,
} = Colors;

export const AmountFilterWrapper = styled.div`
  width: auto;
  display: inline-flex;
`;

export const SubmitButton = styled.button`
  border: none;
  background: transparent;
  color: ${MUTED_PURPLE};
  text-decoration: underline;
  text-transform: none;

  &.disabled {
    color: ${DARK_GREY};
  }

  &:focus,
  &:active {
    outline-color: ${WHITE};
    color: ${MUTED_PURPLE};
  }
  position: relative;
  bottom: 8px;
  right: 8px;
`;

export const StyledLeftFilterNumFormat = styled(NumericFormat)`
  width: 60px;
  display: inline-flex;
  margin: 0px 12px 10px 10px;
  position: relative;
  left: 5px;
`;

export const StyledRightFilterNumFormat = styled(NumericFormat)`
  width: 60px;
  display: inline-flex;
  margin: 0px 10px 10px 10px;
`;
